import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { Subject } from 'rxjs';
import { CommonService } from '../../Model/Common/common.service';
import { EmployeeConfirmationService } from '../../Model/EmployeeConfirmation/employee-confirmation.service';

@Component({
  selector: 'app-questionnaire',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, DataTablesModule, LoaderComponent],
  templateUrl: './questionnaire.component.html',
  styleUrl: './questionnaire.component.scss'
})
export class QuestionnaireComponent {
  isDisabled: boolean = false;
  TableDatas: any[] = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(private router: Router,
    protected common: CommonService,
    private employeeconfirmation: EmployeeConfirmationService,
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }
  
  ngOnInit(): void {
    this.ESS_QuestionnareTemplate();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ESS_QuestionnareTemplate() {
    this.isDisabled = true;
    this.employeeconfirmation.ESS_QuestionnareTemplate({ WEBESSModuleMasterId: 0, SelectType: '1',ESS_QuestionnareTemplateMainId : 0 }).subscribe({
      next: (response) => {
        this.TableDatas = response.Table;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { this.isDisabled = false; },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
}
